import { LogoDark, LogoLight } from "../../SVGComponents";

const AuthHeader = () => {
  return (
    <header className="w-full bg-transparent">
      <div className="container">
        <div className="">
          <a href="/" className="">
            <div className="block dark:hidden">
              <LogoLight />
            </div>
            <div className="hidden dark:block">
              <LogoDark />
            </div>
          </a>
        </div>
      </div>
    </header>
  );
};

export default AuthHeader;